import isObject from 'lodash/isObject'
import * as Sentry from '@sentry/browser'
import cognito from 'shared/cognito'
import correlation from 'shared/correlation'
import packageJson from '../../package.json'
const { release } = packageJson

const REACT_APP_SENTRY_KEY = process.env.REACT_APP_SENTRY_KEY

const saveUserContext = (applicationId, email) => {
  const jwt = cognito.idToken

  Sentry.getCurrentScope().setUser({
    email: email ? email : cognito.currentUser ? cognito.currentUser.username : null,
    applicationId: applicationId ? applicationId : 'no ApplicationId',
    token: jwt ? jwt.substring(jwt.length - 5) : 'no JWT Token',
    sessionId: correlation.getSessionId(),
    correlationId: correlation.getCorrelationId(),
  })
}

export const config = () => {
  if (!Sentry.getClient()) {
    Sentry.init({
      dsn: REACT_APP_SENTRY_KEY,
      release,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
    })
  }
}

export const setUserContext = (applicationId, email) => {
  const user = Sentry.getCurrentScope().getUser()
  if (user) {
    if (user.applicationId !== applicationId)
      saveUserContext(applicationId, email)
  } else {
    saveUserContext(applicationId, email)
  }
}

export const saveError = (error, email) => {
  config()
  const user = Sentry.getCurrentScope().getUser()
  if (Object.keys(user).length === 0) {
    setUserContext(null, email)
  }
  Sentry.captureMessage(isObject(error) ? JSON.stringify(error) : error)
}
